import React from 'react';

const RequestResultOverlay = ({ isActive, title, onPressConfirm, buttonTitle, description }) => {
  return (
    <div className={`modal ${isActive && 'is-active is-clipped'}`}>
      <div className="modal-background"></div>
      <div className="modal-card">
        <header className="modal-card-head">
          <p className="modal-card-title">{title}</p>
        </header>
        <section className="modal-card-body has-background-primary">
          <p>{description}</p>
        </section>
        <footer className="modal-card-foot" style={{justifyContent: 'center'}}>
            <button className="button is-success" onClick={onPressConfirm}>{buttonTitle}</button>
        </footer>
      </div>
    </div>
  )
}

export default RequestResultOverlay;